import { Grid } from '@mui/material';
import React from 'react';
import CircularIndeterminate from '../../../common/CircularLoading';
import Table from '../../../common/Table';
import { APP_ROUTES } from '../../../common/constants/Routes';
import AddIcon from '@mui/icons-material/Add';
import CustomButton from '../../../common/ui/CustomButton';
import { useNavigate } from 'react-router-dom';
import Header from '../../../common/Header';
import { fuelType, status } from '../../../common/constants/dropDownList';
import { GridColDef } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
function Tank() {
  const { t } = useTranslation();
  const loading = false;
  const navigate = useNavigate();
  const columns: GridColDef[] = [
    {
      headerName: t('ID'),
      field: 'tank_serai_no',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('BRANCH'),
      field: 'branch',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },

    {
      headerName: t('TANK_CAPACITY'),
      field: 'tank_capacity',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('TANK_TYPE'),
      field: 'tank_type',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
      renderCell: ({ row }: any) =>
        fuelType.find(
          (data: any) => Number(data.Code) === Number(row?.tank_type)
        )?.Category,
    },
    {
      headerName: t('STATUS'),
      field: 'status',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
      renderCell: ({ row }: any) =>
        status.find((data: any) => Number(data.Code) === Number(row?.status))
          ?.Category,
    },

    {
      headerName: t('AVAIABLE_FUEL'),
      field: 'available_fuel',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },

    {
      headerName: t('ACTION'),
      field: 'Action',
      sortable: false,
      disableColumnMenu: true,
      width: 150,
      renderCell: ({ row }: any) => {
        const handleEditClick = () => {
          navigate(APP_ROUTES.EDITTANK, {
            state: { data: { data: row, type: 'edit' } },
          });
        };

        const handleViewClick = () => {
          navigate(APP_ROUTES.VIEWTANK, {
            state: { data: { data: row, type: 'view' } },
          });
        };

        return (
          <>
            {' '}
            <CustomButton
              text={t('VIEW')}
              className='mx-3'
              color={'secondary'}
              onClick={handleViewClick}
            />
            <CustomButton
              text={t('EDIT')}
              className='mx-3 '
              onClick={handleEditClick}
            />
          </>
        );
      },
    },
  ];
  const data: any[] = [
    {
      id: 'a96907cd-1072-40c8-977e-9f8140962f31',
      branch: 'Elango',
      bunk_details_id: 1,
      tank_capacity: '10000',
      available_fuel: '5000',
      tank_type: 1,
      status: 1,
      tank_serai_no: 'PEOO1',
    },
    {
      id: 'a96907cd-1072-40c8-977e-9f8140962f35',
      branch: 'Elango',
      bunk_details_id: 1,
      tank_capacity: '10000',
      available_fuel: '5000',
      tank_type: 1,
      status: 1,
      tank_serai_no: 'PE002',
    },
    {
      id: '6b2e5c12-d322-4a2e-804e-4cc19186f099',
      branch: 'Elango',
      bunk_details_id: 1,
      status: 1,
      tank_capacity: '10000',
      available_fuel: '5000',
      tank_type: 2,
      tank_serai_no: 'DI001',
    },
    {
      id: '3',
      branch: 'Elango',
      bunk_details_id: 1,
      status: 1,
      tank_capacity: '10000',
      available_fuel: '5000',
      tank_type: 3,
      tank_serai_no: 'PPE001',
    },
    {
      id: '4',
      branch: 'Elango',
      bunk_details_id: 1,
      status: 1,
      tank_capacity: '10000',
      available_fuel: '5000',
      tank_type: 4,
      tank_serai_no: 'PDI001',
    },
  ];
  return (
    <Grid container mb={5}>
      <Grid xs={12} p={2}>
        <Header
          view={true}
          header={t('TANK')}
          buttonName={t('ADD_TANK')}
          route={APP_ROUTES.ADDTANK}
          buttonIcon={AddIcon}
        />
      </Grid>
      {loading ? (
        <Grid xs={12} my={5} display={'flex'} justifyContent={'center'}>
          <CircularIndeterminate />
        </Grid>
      ) : (
        <Grid xs={12} mb={5}>
          <Table
            // totalRecords={
            //   petitionTypeCount
            //     ? petitionTypeCount
            //     : petetionList?.totalRecords || 0
            // }
            rows={data}
            columns={columns}
            // handlePagination={handlePagination}
            // paginationModel={{
            //   page: Number(petetionList?.currentPage) - 1 || 0,
            //   pageSize: Number(petetionList?.pagesize) || 5,
            // }}
            rowHeight={60}
          />
        </Grid>
      )}
    </Grid>
  );
}

export default Tank;
